import { GenialB2bPartnerPortalBFFWebApiDomainInterfacesRequestSortItem } from '@genial/services/dist/models';

export const execSort = <T>(
  dataToFilter: T[],
  sortBy: GenialB2bPartnerPortalBFFWebApiDomainInterfacesRequestSortItem
): T[] => {
  const { sort, sortDirection } = sortBy;

  if (!sort || !sortDirection) {
    return dataToFilter;
  }
  const isAsc = sortDirection === 'asc';

  return dataToFilter.sort((a, b) => {
    if (a[sort] < b[sort]) {
      return isAsc ? -1 : 1;
    }
    if (a[sort] > b[sort]) {
      return isAsc ? 1 : -1;
    }
    return 0;
  });
};
